<template>
<div class="loader" v-if="isLoading">
  <div class="line"></div>
  <div class="line"></div>
  <div class="line"></div>
  <div class="line"></div>
</div>
<v-container class="mt-5" grid-list-md text-xs-left v-else>
  <v-layout row wrap>
    <v-flex xs12 sm6>
      <h1>{{ activeGroup.projectTitle }}</h1>
    </v-flex>
    <v-flex xs12 sm6>
      <h3 class="green--text text--lighten-1"><v-icon small color="green lighten-1">cast_connected</v-icon> Checkins - <v-chip color="green--text text--lighten-1">{{ getAbrev(activeGroup.meetingDays) }} | {{ activeGroup.meetingTime[0] | grabTime }}-{{ activeGroup.meetingTime[1] | grabTime  }}</v-chip></h3>
    </v-flex>
    <v-flex xs12>
      <v-expansion-panel flat>
        <v-expansion-panel-content>
          <div v-on:click="expandToggle" slot="header" class="bold green--text text--lighten-1">
            <h3 class="bold green--text text--lighten-1">Details:</h3></div>
          <v-icon v-on:click="expandToggle" v-if="!ProjDets" slot="actions" color="primary">add</v-icon>
          <v-icon v-else v-on:click="expandToggle" slot="actions" color="primary">close</v-icon>
          <v-card flat tile>
            <v-card-text class="px-4">
              <p><span class="green--text text--lighten-1"><strong>Location:</strong></span> {{ activeGroup.location }}</p>
              <span class="green--text text--lighten-1"><strong>Description:</strong></span>
              <p v-html="activeGroup.extraInfo"></p>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
    <v-flex xs12 sm6>
      <Calendar></Calendar>
    </v-flex>
    <v-flex xs12 sm6>
      <Article></Article>
    </v-flex>
    <v-flex xs12 sm6>
      <ToDo></ToDo>
    </v-flex>
    <v-flex xs12 sm6>
      <UpFile></UpFile>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import {
  checkAccess
} from "@/scripts/groupFuncs";
import {
  db
} from "@/firebaseConfig";
import {
  mapGetters
} from "vuex";
import moment from 'moment'
import Calendar from "@/components/Calendar/Calendar";
import Article from "@/components/Posts/Article";
import ToDo from "@/components/Posts/Todo";
import UpFile from "@/components/Posts/UpFile";
export default {
  name: "GroupHomePage",
  components: {
    Calendar,
    ToDo,
    UpFile,
    Article
  },
  data() {
    return {
      activeGroup: null,
      isMember: false,
      isLoading: true,
      ProjDets: false
    };
  },
  created() {
    this.loadGroupData(this.$route.params.groupID);
  },
  methods: {
    expandToggle: function(event) {
      this.ProjDets = !this.ProjDets
    },
    getTime(time) {
      try {
        let hour = parseInt(time.split(":")[0]);
        let minutes = time.split(":")[1];
        return ((hour + 11) % 12) + 1 + ":" + minutes;
      } catch (err) {
        // console.log(err);
      }
    },
    getAbrev(days) {
      let string = "";
      days.forEach(day => {
        if (day === "Thursday") {
          string += day.slice(0, 2) + " ";
        } else {
          string += day.charAt(0).toUpperCase() + " ";
        }
      });
      return string;
    },
    loadGroupData(groupID) {
      // console.log("Sidebar: Loading Group Data function...");

      // Make sure the user is part of the group
      checkAccess(this.$store.getters.uid, this.$route.params.groupID)
        .then(() => {
          // If they are... load the group's data.
          this.$bind(
            "activeGroup",
            db.collection("projects").doc(groupID)
          ).then(active => {
            this.activeGroup === active;
            this.$store.commit("setActiveGroup", {
              groupID: active.id,
              details: active
            });
            this.isMember = true;
            this.isLoading = false;
          });
        })
        .catch(() => {
          // console.log("You are not a member!");
          this.isLoading = false;
        });
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.$forceUpdate();
    })
  },
  filters: {
    grabTime(value) {
      return moment(String(value), 'HH:mm').format('h:mm A')
      //return moment(String(value)).format('hh:mm a');
    }
  },
  watch: {
    "$route.params.groupID" (id) {
      this.$forceUpdate();
      // console.log(
      //   "Sidebar: Active Group Changed - Getting new data from firestore"
      // );
      this.loadGroupData(id);
    }
  }
};
</script>
<style lang="scss" scoped>
.loader {
    position: absolute;
    top: 50%;
    left: 48%;
}

.line {
    animation: expand 1s ease-in-out infinite;
    border-radius: 10px;
    display: inline-block;
    transform-origin: center center;
    margin: 0 3px;
    width: 1px;
    height: 25px;
}
.line:nth-child(1) {
    background: #66bb6a;
}
.line:nth-child(2) {
    animation-delay: 180ms;
    background: #7a7a7a;
}
.line:nth-child(3) {
    animation-delay: 360ms;
    background: #66bb6a;
}
.line:nth-child(4) {
    animation-delay: 540ms;
    background: #7a7a7a;
}
@keyframes expand {
    0% {
        transform: scale(1);
    }
    25% {
        transform: scale(2);
    }
}
</style>



// WEBPACK FOOTER //
// src/views/GroupHomePage.vue